import { centsToDollars, dollarsToCents } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class PricingEditSection extends React.Component {
  newPriceHeader() {
    return this.props.adjustmentAmount > 0
      ? "New Price (w/ adjustment)"
      : "New Price"
  }

  newPriceSection() {
    if (this.props.isCalculating) {
      return (
        <div>
          <i className="icon icon-spinner icon-spin h4 text-muted bs-mt-4" />
        </div>
      )
    } else {
      return (
        <div>
          <div className="text-black">{this.newPriceHeader()}</div>
          <span className="h3 font-semibold">
            {centsToDollars(
              this.props.newPrice + this.adjustmentAmountInCents()
            )}
          </span>
        </div>
      )
    }
  }

  adjustmentAmountInCents() {
    if (this.props.adjustmentAmount) {
      return dollarsToCents(this.props.adjustmentAmount)
    } else {
      return 0
    }
  }

  renderUsePreservedRatesCheckbox() {
    if (!this.props.ratePreservationEnabled || !this.props.hasPreservedRates)
      return null

    return (
      <div className="checkbox mb-0 ml-2 mt-3">
        <label>
          <input
            type="checkbox"
            name="usePreservedRates"
            checked={this.props.usePreservedRates}
            onChange={this.props.handlePreservedRateChange}
          />
          Use preserved rates
        </label>
      </div>
    )
  }

  renderPreservedRateAlerts() {
    if (this.props.ratePreservationEnabled && !this.props.hasPreservedRates) {
      return (
        <div className="alert alert-danger mx-4 mt-4 text-left">
          This reservation has no preserved rates associated with it. This means
          that edits may result in an unintentional price change. Be sure to
          double check the new calculated price before saving.{" "}
          <strong>Note:</strong> We are phasing out reservations without
          preserved rates and this will no longer be an issue on new
          reservations.
        </div>
      )
    } else if (
      this.props.ratePreservationEnabled &&
      this.props.hasPreservedRates &&
      !this.props.usePreservedRates
    ) {
      return (
        <div className="alert alert-blue mx-2 my-2 text-left">
          When <strong>Use preserved rates</strong> is turned off, the
          reservation will be recalculated off of current rates and not off of
          the rates when the reservation was created. If your rates have
          changed, this may affect the price this customer pays.
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className="bg-gray bs-p-4 rounded text-center text-teal-700">
              <div className="text-black">Current Price</div>
              <span className="h3 font-semibold">
                {centsToDollars(this.props.currentPrice)}
              </span>
            </div>
          </div>
          <div className="col-sm-6">
            <div
              className="bg-gray bs-p-4 rounded text-center text-teal-700"
              style={{ height: 77 }}
            >
              {this.newPriceSection()}
            </div>
            {this.renderUsePreservedRatesCheckbox()}
          </div>
        </div>
        {this.renderPreservedRateAlerts()}
      </div>
    )
  }
}

PricingEditSection.propTypes = {
  currentPrice: PropTypes.number.isRequired,
  newPrice: PropTypes.number,
  adjustmentAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isCalculating: PropTypes.bool,
  usePreservedRates: PropTypes.bool,
  handlePreservedRateChange: PropTypes.func,
  ratePreservationEnabled: PropTypes.bool,
  hasPreservedRates: PropTypes.bool,
}

export default PricingEditSection
